module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-mv-fe9490c0a8e773a25abff990c3d0445c.jpg";